import smalltalk from "refractor/smalltalk";
export default smalltalk;